import { ShieldCheck } from "lucide-react";

export default function Mitigations({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <section
      data-testid="mitigations"
      className="panel p-6 md:p-7 fade-up delay-4"
    >
      <div className="flex items-center gap-2 mb-4">
        <ShieldCheck className="h-4 w-4 text-emerald-700" />
        <div className="overline">Mitigations · Detection</div>
      </div>
      <h3 className="font-display text-xl text-slate-900 mb-4">
        What to do about it
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {items.map((m, i) => (
          <div
            key={i}
            className="bg-slate-50 border border-slate-200 rounded-md p-4 panel-hover"
          >
            <div className="overline text-emerald-700 mb-2">{m.title}</div>
            <p className="text-sm text-slate-700 leading-relaxed">{m.detail}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
